import { useAppSelector } from 'reduxTyped'

import { IBuilderState } from 'common/builder/builderInterfaces'
import * as builderStateSelectors from 'common/builder/selectors/builder/builderStateSelectors'

export const useBuilderState = (builderId: string): IBuilderState | undefined => {
  return useAppSelector((state) => builderStateSelectors.getById(state, builderId))
}
